import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner, Modal, Button, Toast } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTest } from '../../redux/GetAllTestSlice';
import { homeData } from '../../redux/HomeSlice';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

const Package = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { categorySlug } = useParams();

    const responseHome = useSelector((state) => state.homeReducer.data);
    const responseHomeLoading = useSelector((state) => state.homeReducer.isLoading);
    const allTestResponse = useSelector((state) => state.getAllTestReducer.data);
    const allTestLoading = useSelector((state) => state.getAllTestReducer.isLoading);

    const [allTest, setAllTest] = useState([]);
    const [homeData2, setHomeData] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');

    // helper to create URL-friendly slugs
    const slugify = (text) =>
        text
            ?.toString()
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '') || '';

    // load home categories
    useEffect(() => {
        dispatch(homeData());
    }, [dispatch]);

    // when home data loads OR url category changes
    useEffect(() => {
        if (responseHome?.status === 1) {
            const data = responseHome.data;

            const categories = (data?.categories || []).map((c) => ({
                ...c,
                slug: c.slug || slugify(c.name),
            }));

            setHomeData({ ...data, categories });

            const selectedBySlug = categorySlug
                ? categories.find((c) => c.slug === categorySlug || c._id === categorySlug)
                : null;

            const defaultCategoryId = selectedBySlug?._id || categories?.[0]?._id;

            if (defaultCategoryId) {
                dispatch(getAllTest(defaultCategoryId));
            }

            const index = categories?.findIndex((c) => c._id === (selectedBySlug?._id || categories?.[0]?._id));
            setSelectedIndex(index >= 0 ? index : 0);
        }
    }, [responseHome, categorySlug, dispatch]);

    // when test api response arrives
    useEffect(() => {
        if (allTestResponse?.status === 1) {
            setAllTest(allTestResponse.data);
        } else if (!allTestResponse) {
            setAllTest([]);
        }
    }, [allTestResponse]);

    const clickOnCategory = (index, cat) => {
        setSelectedIndex(index);
        const slug = cat.slug || slugify(cat.name);
        navigate(`/package/${slug}`);
    };

    const addToCart = (item) => {
        try {
            const cart = JSON.parse(localStorage.getItem('cart') || '[]');
            const exists = cart.find((c) => c._id === item._id);
            if (!exists) cart.push({ _id: item._id, name: item.name, amount: item.amount });
            localStorage.setItem('cart', JSON.stringify(cart));
            setToastMsg('Added to cart');
            setShowToast(true);
        } catch (err) {
            setToastMsg('Unable to add to cart');
            setShowToast(true);
        }
    };

    const openDetails = (item) => {
        setModalData(item);
        setShowModal(true);
    };
    
    const selectedCategoryData =
        homeData2?.categories?.find((c) => c.slug === categorySlug || c._id === categorySlug) ||
        homeData2?.categories?.[selectedIndex];
    

    return (
        <>
            <Helmet>
                <title>
                    {selectedCategoryData?.name
                        ? `${selectedCategoryData.name} | Preventive Health Packages`
                        : 'Preventive Health Packages'}
                </title>
                <meta
                    name="description"
                    content={
                        selectedCategoryData?.description ||
                        'Explore modern preventive health packages including lab tests, imaging, X-ray, ultrasound and annual health checkups.'
                    }
                />
            </Helmet>

            <div className="package">
                {/* HERO / BANNER */}
                <div className="package_hero">
                    {selectedCategoryData?.bannerImage && (
                        <img
                            src={selectedCategoryData.bannerImage}
                            alt={selectedCategoryData?.name}
                            className="hero_banner"
                        />
                    )}

                    <h1>{selectedCategoryData?.name || 'Preventive Health Tests'}</h1>

                    <p>
                        {selectedCategoryData?.description ||
                            'Early detection. Smart diagnostics. Better care.'}
                    </p>
                </div>

                <div className="coustom_container">
                    <Row className="package_layout">
                        {/* SIDEBAR */}
                        <Col lg={3} md={4} sm={12}>
                            <div className="package_sidebar">
                                <div className="sidebar_header">
                                    <span className="icon">🧪</span>
                                    <h5>Categories</h5>
                                </div>

                                <ul className="category_list">
                                    {homeData2?.categories?.map((item, index) => (
                                        <li key={item._id || item.id} className={index === selectedIndex ? 'active' : ''} onClick={() => clickOnCategory(index, item)}>
                                            <span className="dot"></span>
                                            {item.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        {/* CONTENT */}
                        <Col lg={9} md={8} sm={12}>
                            <div className="package_content">
                                <Row>
                                    { (responseHomeLoading || allTestLoading) ? (
                                        <div className="text-center w-100 py-5">
                                            <Spinner animation="border" />
                                            <div className="mt-2">Loading packages...</div>
                                        </div>
                                    ) : allTest?.length ? (
                                        allTest.map((item) => (
                                            <Col lg={4} md={6} sm={12} key={item._id || item.id}>
                                                <Card className="package_card">
                                                    <Card.Body>
                                                        <h6 className="title">{item.name}</h6>

                                                        <div className="price">₹ {item.amount}</div>

                                                        <div className="actions">
                                                            <Button className="btn_primary" onClick={() => addToCart(item)}>Add to Cart</Button>

                                                            <Button variant="link" className="btn_link" onClick={() => openDetails(item)}>Know More →</Button>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))
                                    ) : (
                                        <div className="text-center w-100 py-5">
                                            <h5>No packages found for this category.</h5>
                                            <p>If you believe this is an error, please contact us at support.</p>
                                        </div>
                                    )}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalData?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{modalData?.description || 'No description available.'}</p>
                        <p><strong>Price: </strong>₹ {modalData?.amount}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button variant="primary" onClick={() => { addToCart(modalData); setShowModal(false); }}>Add to Cart</Button>
                    </Modal.Footer>
                </Modal>

                <Toast onClose={() => setShowToast(false)} show={showToast} delay={2000} autohide style={{ position: 'fixed', right: 20, bottom: 20 }}>
                    <Toast.Body>{toastMsg}</Toast.Body>
                </Toast>
            </div>
        </>
    );
};

export default Package;
